module.exports = __webpack_public_path__ + "static/media/more_games_vi.8915353c.png";